import "../../sass/components/Spinner.scss";

export default function Spinner() {
    return (
        <div className="spinner-container">
            <i className="far fa-spinner-third"/>
        </div>
    )
}
